import { LmgService } from "../resource";

const TtypeModule = {
  namespaced: true,
  state: {
    datas: [],
    codes: [],
    data: {},
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_CODES(state, payload) {
      state.codes = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.TTypeCreate(payload);
    },
    updateData({ commit, state }, payload) {
      return LmgService.TTypeUpdate(payload.ID,payload);
    },
    async listData({ commit, state },payload) {
      try {
        const data = await LmgService.TTypeList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    },
    async listCode({ commit, state },payload) {
      try {
        const data = await LmgService.TTypeCodeList(payload);
        if (data.data.Data == null) {
          commit("SET_CODES", []);
        } else {
          commit("SET_CODES", data.data.Data);
        }
      } catch (err) {
        commit("SET_CODES", []);
      }
    },
  },
  getters: {
    getData(state) {
      return state.datas;
    },
    getCode(state) {
      return state.codes;
    },
    getActiveData(state) {
      return state.datas.filter((i)=>{
        return i.IsActive == 1
      });
    },
    
  }
};

export default TtypeModule;
